<template lang="html">
    <div>
        <UiInput
            label="Titlu"
            image="info.svg"
            placeholder="Trainer / Psiholog/ Psihiatru, etc."
            :value="fourthStep.title"
            :error="errors.title"
            @input="updateTitle"
            @blur="validateTitle"
            @focus="errors.title = ''"
        />

        <UiInput
            label="Preț de bază"
            type="number"
            image="coins.svg"
            placeholder="Introduceți prețul unei ședinte"
            :value="fourthStep.base_price"
            :error="errors.base_price"
            @input="updateBaseprice"
            @blur="validateBaseprice"
            @focus="errors.base_price = ''"
        />
        
        <UiInput
            label="Preț per minut ( ședință acum )"
            type="number"
            image="coins.svg"
            placeholder="Introduceți prețul unei ședinte"
            :value="fourthStep.minute_base_price"
            :error="errors.minute_base_price"
            @input="updateMinuteBaseprice"
            @blur="validateMinuteBaseprice"
            @focus="errors.minute_base_price = ''"
        />

        <UiInput
            label="Număr minim de ședințe (o ședința = 30min)"
            type="number"
            image="address-card.svg"
            placeholder="Introduceți numărul de ședințe"
            :value="fourthStep.min_services"
            :error="errors.min_services"
            v-model="fourthStep.min_services"
            @input="updateMinServices"
            @blur="validateMinServices"
            @focus="errors.min_services = ''"
        />

        <p v-for="error in apiErrors" :key="error" class="error">{{error}}</p>
    </div>
</template>

<script>
import UiInput from '@/components/ui/Input'
import { mapGetters } from 'vuex'

export default {
    components: {
        UiInput
    },
    data() {
        return {
            errors: {
                title: '',
                base_price: '',
                min_services: '',
            },
            apiErrors: []
        }
    },
    computed: {
        ...mapGetters({
            fourthStep: 'settings/fourthStep'
        })
    },
    methods: {
        validateTitle() {
            this.apiErrors = [];
            if(this.fourthStep.title.length > 0 && this.fourthStep.title.length < 3 || this.fourthStep.title.length > 20)
                this.errors.title = 'Titlul trebuie să conțina minim 3 si maxim 30 de caractere';
            else this.errors.title = '';
        },
        validateBaseprice() {
            this.apiErrors = [];
            if(this.fourthStep.base_price <= 0 && this.fourthStep.base_price > 5000)
                this.errors.base_price = 'Prețul trebuie să fie intre 0-5000';
            else this.errors.base_price = '';
        },
        validateMinuteBaseprice() {
            this.apiErrors = [];
            if(this.fourthStep.minute_base_price <= 0 && this.fourthStep.minute_base_price > 5000)
                this.errors.minute_base_price = 'Prețul trebuie să fie intre 0-5000';
            else this.errors.minute_base_price = '';
        },
        validateMinServices() {
            this.apiErrors = [];
            if(this.fourthStep.min_services <= 0 && this.fourthStep.min_services > 4)
                this.errors.min_services = 'Numărul de servicii pentru o programare trebuie să fie intre 1 și 4 inclusiv';
            else this.errors.min_services = '';
            console.log(this.fourthStep.min_services);
        },
        activeButton() {
            if((this.fourthStep.title.length >= 3
                &&  this.fourthStep.title.length <= 30)
                && (this.fourthStep.base_price > 0
                && this.fourthStep.base_price <= 5000)
                && (
                    this.fourthStep.min_services > 0
                    && this.fourthStep.min_services < 5
                ))
                this.$emit('activeButton', true);
            else
                this.$emit('activeButton', false);
        },
        updateTitle(event) {
            this.$store.state.settings.steps[3].payload['title'] = event;
            this.activeButton();
        },
        updateBaseprice(event) {
            this.$store.state.settings.steps[3].payload['base_price'] = event;
            this.activeButton();
        },
        updateMinuteBaseprice(event) {
            this.$store.state.settings.steps[3].payload['minute_base_price'] = event;
            this.activeButton();
        },
        updateMinServices(event) {
            this.$store.state.settings.steps[3].payload['min_services'] = event;
            this.activeButton();
            this.validateMinServices();
        }
    },
    watch: {
        "$store._modules.root.state.notification.notification"(notification) {
             if(notification.icon == 'error' && this.$store._modules.root.state.settings.currentStep == 3) {
                this.errors = [];
                this.apiError = notification;
            }
		}
    }
}
</script>
